var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnimatedShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 1440,
    height: 720,
    preserveAspectRatio: "none",
    viewBox: "0 0 1440 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(\"#SvgjsMask1470\")",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 720,
    x: 0,
    y: 0,
    fill: "url(#SvgjsLinearGradient1471)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.658,358.098C860.997,359.035,888.667,320.6,909.115,284.66C929.262,249.248,944.658,207.854,925.637,171.825C905.596,133.863,862.559,113.703,819.658,115.21C779.182,116.632,743.939,142.613,725.839,178.845C709.471,211.61,719.974,248.308,736.958,280.758C755.717,316.599,779.215,357.181,819.658,358.098",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.245,649.977C726.277,650.42,741.454,634.082,751.369,616.67C761.159,599.478,765.622,579.151,756.607,561.541C746.803,542.391,727.731,527.42,706.245,528.525C686.058,529.563,672.937,548.106,664.119,566.295C656.568,581.872,656.663,599.288,664.447,614.75C673.228,632.193,686.721,649.546,706.245,649.977",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.362,394.136C633.084,392.609,671.091,378.266,691.104,345.081C711.749,310.848,711.034,268.024,691.426,233.187C671.431,197.663,635.126,173.49,594.362,173.203C553.12,172.912,516.531,196.687,494.899,231.802C472.037,268.914,460.663,316.103,483.436,353.27C505.501,389.282,552.161,395.8,594.362,394.136",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.354,519.018C1011.233,518.49,1024.475,500.657,1033.931,483.163C1042.804,466.748,1048.018,447.412,1038.841,431.164C1029.541,414.698,1010.259,408.244,991.354,407.779C971.426,407.288,949.898,411.632,939.637,428.722C929.149,446.191,934.544,467.853,944.671,485.534C954.872,503.345,970.836,519.563,991.354,519.018",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.758,860.633C1252.918,860.093,1308.165,855.266,1334.739,812.72C1362.483,768.301,1352.095,710.72,1323.998,666.523C1297.949,625.547,1251.313,605.331,1202.758,605.112C1153.768,604.891,1106.328,624.359,1079.606,665.419C1050.212,710.585,1037.01,770.039,1065.762,815.616C1093.25,859.189,1151.242,861.188,1202.758,860.633",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.846,714.443C1360.672,713.868,1401.894,703.794,1421.035,670.009C1439.978,636.574,1426.789,596.525,1407.472,563.305C1388.287,530.312,1360.011,499.728,1321.846,499.431C1283.29,499.131,1253.751,528.913,1233.878,561.954C1213.203,596.328,1197.393,638.276,1217.437,673.022C1237.49,707.783,1281.72,715.037,1321.846,714.443",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.799,249.65C304.536,251.328,342.562,235.082,359.185,202.278C374.721,171.62,358.083,137.034,339.527,108.104C322.847,82.099,298.692,60.122,267.799,59.802C236.416,59.477,209.17,79.427,193.448,106.59C177.694,133.809,175.311,166.636,189.814,194.541C205.547,224.813,233.719,248.093,267.799,249.65",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.976,564.481C336.057,569.519,414.336,552.224,454.346,490.862C497.595,424.532,496.813,336.774,455.49,269.227C415.775,204.309,339.01,174.803,262.976,178.048C192.579,181.053,129.497,222.027,96.966,284.529C66.713,342.655,79.009,410.928,112.432,467.291C145.085,522.356,199.109,560.078,262.976,564.481",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.724,615.154C395.497,613.234,421.402,602.399,436.891,579.267C454.536,552.916,464.342,520.076,450.489,491.549C435.005,459.663,403.15,435.615,367.724,436.829C333.833,437.991,311.116,467.494,294.236,496.905C277.458,526.139,261.948,561.502,279.74,590.131C296.99,617.888,335.122,617.408,367.724,615.154",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.792,278.721C1299.361,280.063,1320.936,265.362,1332.478,244.769C1343.771,224.622,1342.454,200.223,1331.048,180.14C1319.491,159.79,1299.185,145.639,1275.792,144.955C1251.182,144.236,1225.566,154.672,1214.642,176.737C1204.519,197.182,1217.551,219.328,1229.283,238.894C1240.533,257.656,1253.951,277.477,1275.792,278.721",
    fill: "rgba(62, 10, 10, 0.4)",
    className: "triangle-float1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "SvgjsMask1470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 720,
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.5%",
    y1: "-25%",
    x2: "87.5%",
    y2: "125%",
    gradientUnits: "userSpaceOnUse",
    id: "SvgjsLinearGradient1471"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 90, 90, 1)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(149, 28, 8, 1)",
    offset: 1
  })), /*#__PURE__*/React.createElement("style", null, "\n            @keyframes float1 {\n                0%{transform: translate(0, 0)}\n                50%{transform: translate(-10px, 0)}\n                100%{transform: translate(0, 0)}\n            }\n\n            .triangle-float1 {\n                animation: float1 5s infinite;\n            }\n\n            @keyframes float2 {\n                0%{transform: translate(0, 0)}\n                50%{transform: translate(-5px, -5px)}\n                100%{transform: translate(0, 0)}\n            }\n\n            .triangle-float2 {\n                animation: float2 4s infinite;\n            }\n\n            @keyframes float3 {\n                0%{transform: translate(0, 0)}\n                50%{transform: translate(0, -10px)}\n                100%{transform: translate(0, 0)}\n            }\n\n            .triangle-float3 {\n                animation: float3 6s infinite;\n            }\n        "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedShape);
export default __webpack_public_path__ + "static/media/animated-shape.fbfc889ec678e337e44e43f0319159e1.svg";
export { ForwardRef as ReactComponent };